import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy `/account/events` now redirects to the public `/events` listing.
 * The standalone public page is richer (upcoming hero + past archive)
 * and login-less browsing is preferable.
 */
export default function AccountEventsPage() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/events', { replace: true }); }, [navigate]);
  return null;
}
